/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsApiErrorResponseSchema = z.object({
  code: z.string().nullish(),
  message: z.string().nullish(),
});
